module.exports = __webpack_public_path__ + "img/upgrade_plan_icon.b07ab19a.svg";